import { Urls } from "./urls.interface.ts";

export const prodUrls: Urls = {
  APP_STORE:
    "https://apps.apple.com/ru/app/wb-%D0%BF%D0%B0%D1%80%D1%82%D0%BD%D1%91%D1%80%D1%8B/id1466739454",
  GOOGLE_PAY:
    "https://play.google.com/store/apps/details?id=com.wildberries.portal&hl=ru&gl=US",
  TG_BOT: "https://t.me/tablo_wb_bot",
  GET_INFO: "https://tablo.wb.ru//api/get_info",
  GET_INFO_BY_WAREHOUSE: "https://tablo.wb.ru//api/get_info_by_warehouse",
  GET_WAREHOUSE_QUEUE: "https://tablo.wb.ru/api/warehouse/getWarehouseQueue",
  GET_WAITING_CAR: "https://tablo.wb.ru/api/warehouse/getWaitingCar",
  GET_UNLOADED_CAR: "https://tablo.wb.ru/api/warehouse/getUnloadedCar",
  GET_WAREHOUSE_QUEUE_BY_NEW_API: "https://logistics.wb.ru/keeper-bff/v1",
  KEEPER_BFF: "https://logistics.wb.ru/keeper-bff",
  INSTRUCTIONS:
    "https://link.rwb.ru/p/3ZgSmfz8/instruktsiya-dlya-voditeley-eop",
  PUBLIC_API: "https://logistics-internal.wb.ru/keeper-bff",
};
